<template>
  <div>
    <v-row>

      <v-col cols="6">
        <v-card>
          <v-card-title>
            اطلاعات شرکت
          </v-card-title>
          <v-card-text >
            <v-text-field
                v-model="model.company_name"
                dense
v-show="false"
                id="company_name"
                v-on:keyup.enter="another_focus('company_address')"
                label="نام موسسه"/>
            <v-text-field
                id="company_address"
                v-model="model.company_address"
                dense
v-show="false"
                v-on:keyup.enter="another_focus('tak_tonaje_limit')"
                label="آدرس موسسه"/>
            <v-text-field
                id="tak_tonaje_limit"
                v-model="model.tak_tonaje_limit"
                dense
                @keypress="isNumber"

                v-on:keyup.enter="another_focus('joft_tonaje_limit')"
                label="سقف تناژ تک"/>
            <v-text-field
                id="joft_tonaje_limit"
                v-model="model.joft_tonaje_limit"
                dense
                @keypress="isNumber"
                v-on:keyup.enter="another_focus('tonaje_limit')"
                label="سقف تناژ جفت"/>

            <v-row>
              <v-checkbox
                  id="tonaje_limit"
                  label="سقف تناژ رعایت شود"
                  :value.sync="model.tonaje_limit"
                  v-model="model.tonaje_limit"
              />
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn  color="warning" id="edit_truck" @click="insert_data()">ویرایش
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Vue from 'vue'
import { bus } from '../main'

export default {
  name: 'OriginDownload',
  components: {},
  data () {
    return {
      confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
      items: [],
      status_form: 0,
      model: {
        company_name: '',
        company_address: '',
        tak_tonaje_limit: '20',
        joft_tonaje_limit: '20',
        tonaje_limit: false,

      },
    }
  },
  mounted () {
    this.get_data()
  },
  methods: {
    reset_form () {
      this.model = {
        company_name: '',
        company_address: '',
        tak_tonaje_limit: '20',
        joft_tonaje_limit: '20',
        tonaje_limit: false,

      }
      this.status_form = 0
    },
    edit_item (item) {
      var self = this;
      item.forEach(function (val){
        if(val.code=="tonaje_limit"){
          if (val.value == 1) {
            self.model.tonaje_limit = true
          } else {
            self.model.tonaje_limit = false
          }
        }
        if(val.code=="company_name"){
          self.model.company_name = val.value

        }
        if(val.code=="company_address"){
          self.model.company_address = val.value

        }
        if(val.code=="tak_tonaje_limit"){
          self.model.tak_tonaje_limit = val.value

        }
        if(val.code=="joft_tonaje_limit"){
          self.model.joft_tonaje_limit = val.value
        }
      })




    },
    get_data () {
      var self = this
      const formData = new FormData()
      // formData.append('id', this.selected_province);
      this.axios.post('/api/settings/select', formData, {}).then(function (response) {

        // items = content_cats.orders;
        if (response.data.error == 0) {

          self.edit_item(response.data.data)
        } else {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

        }

      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },
    insert_data () {
      var self = this
      const formData = new FormData()
      // formData.append('id', this.selected_province);
      var url = '/api/settings/update'

      formData.append('company_name', this.model.company_name)
      formData.append('company_address', this.model.company_address)
      formData.append('tak_tonaje_limit', this.model.tak_tonaje_limit)
      formData.append('joft_tonaje_limit', this.model.joft_tonaje_limit)
      if (this.model.tonaje_limit) {
        formData.append('tonaje_limit', 1)
      } else {
        formData.append('tonaje_limit', 0)
      }

      this.axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response)

        // items = content_cats.orders;
        if (response.data.error == 0) {
          self.reset_form()
          self.get_data()
        }
      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },

  }
}
</script>
